import { type GetStaticProps } from 'next';

import { ErrorTemplate } from '../templates';

const SERVER_SIDE_ERROR_MESSAGE = {
  title: 'Ops, ocorreu um erro no servidor',
  text: 'Tivemos dificuldades para exibir a página que você está tentando acessar. Por favor, tente novamente mais tarde.',
};

export default function ServerError() {
  return <ErrorTemplate {...SERVER_SIDE_ERROR_MESSAGE} />;
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
